import { render } from "./CompletedDealsPage.vue?vue&type=template&id=132e7209&scoped=true"
import script from "./CompletedDealsPage.vue?vue&type=script&lang=js"
export * from "./CompletedDealsPage.vue?vue&type=script&lang=js"

import "./CompletedDealsPage.vue?vue&type=style&index=0&id=132e7209&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-132e7209"]])

export default __exports__